import React from 'react'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const LoanTypeListPageUI = ({context, loanTypeList, onRefreshClick}) =>
  <SuperUserSettingsPageUI context={context} className='pg_su_l_types' topnav='settings' backLink='/su/settings'
    headerText='Loan types' centered={!loanTypeList} page='loanTypes'
  >
    {
      !loanTypeList &&
      <SpinnerComponentUI />
    }
    {
      loanTypeList && loanTypeList.length !== 0 &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/su/settings' titleText='Loan types' />
        <LoanTypeListUI
          context={context}
          loanTypeList={loanTypeList}
          onRefreshClick={onRefreshClick}
        />
      </div>
    }
  </SuperUserSettingsPageUI>

const LoanTypeListUI = ({context, loanTypeList, onRefreshClick}) =>
  <div>
    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
        </div>
      }
      right={<span />}
    />

    <LRTableBodyUI>
      {
        loanTypeList.map((loanType, i) =>
          <LoanTypeRowUI key={i} context={context} loanType={loanType} />
        )
      }
    </LRTableBodyUI>
  </div>

  const LoanTypeRowUI = ({context, loanType}) =>
    <LRTableRowUI
      context={context}
      left={<RowLeftUI context={context} loanType={loanType} />}
      right={<RowRightUI loanType={loanType} />}
    />

  const RowLeftUI = ({context, loanType}) =>
    <div>
      <div>
        <span><b>{loanType.name}</b></span>
        <span className='g_muted g_m_left_50'>{loanType.code}</span>
      </div>
      {
        loanType.agreementDocList.map((doc, i) =>
          <div key={i}>
            <span>{doc.name}</span>
            <span className='g_muted g_m_left_50'>{doc.code}</span>
          </div>
        )
      }
      <div>
      </div>
    </div>

 const RowRightUI = ({context, loanType}) =>
  <div>
  </div>

export default LoanTypeListPageUI
